import React, { useRef, useState } from "react";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Swiper, SwiperSlide } from "swiper/react";
import { Link } from 'react-router-dom';

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation, Pagination, Autoplay } from "swiper";

// Data
import ArrivalData1 from "./ArrivalData1"
import ArrivalData2 from "./ArrivalData2"
import ArrivalData3 from "./ArrivalData3"
import ArrivalData4 from "./ArrivalData4"
import ArrivalData5 from "./ArrivalData5"
import ArrivalData6 from "./ArrivalData6"
import ArrivalData7 from "./ArrivalData7"
import ArrivalData8 from "./arrivalData8"

function NewArrival() {
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    let [data1] = useState(ArrivalData1)
    let [data2] = useState(ArrivalData2)
    let [data3] = useState(ArrivalData3)
    let [data4] = useState(ArrivalData4)
    let [data5] = useState(ArrivalData5)
    let [data6] = useState(ArrivalData6)
    let [data7] = useState(ArrivalData7)
    let [data8] = useState(ArrivalData8)

    let [res1, setRes1] = useState([0, 1, 2, 3]);
    let [res2, setRes2] = useState([4, 5, 6, 7]);
    let [res3, setRes3] = useState([8, 9, 10, 11]);
    let [res4, setRes4] = useState([12, 13, 14, 15]);
    let [res5, setRes5] = useState([16, 17, 18, 19]);
    let [res6, setRes6] = useState([20, 21, 22, 23]);
    let [res7, setRes7] = useState([24, 25, 26, 27]);
    let [res8, setRes8] = useState([28, 29, 30, 31]);

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                    <Tab label="여성" {...a11yProps(0)} />
                    <Tab label="남성" {...a11yProps(1)} />
                    <Tab label="잡화/슈즈" {...a11yProps(2)} />
                    <Tab label="골프/스포츠" {...a11yProps(3)} />
                </Tabs>
            </Box>
            <TabPanel value={value} index={0} style={{ width: '1240px', margin: '0 auto' }}>
                <Swiper
                    loop={true}
                    cssMode={true}
                    navigation={true}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    pagination={true}
                    modules={[Navigation, Pagination, Autoplay]}
                    className="mySwiper"
                >
                    <SwiperSlide>
                        <Womenbox1 data1={data1} res1={res1} />
                    </SwiperSlide>
                    <SwiperSlide>
                        <Womenbox2 data2={data2} res2={res2} />
                    </SwiperSlide>
                </Swiper>
            </TabPanel>
            <TabPanel value={value} index={1} style={{ width: '1240px', margin: '0 auto' }}>
                <Swiper
                    loop={true}
                    cssMode={true}
                    navigation={true}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    pagination={true}
                    modules={[Navigation, Pagination, Autoplay]}
                    className="mySwiper"
                >
                    <SwiperSlide>
                        <Menbox1 data3={data3} res3={res3}/>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Menbox2 data4={data4} res4={res4}/>
                    </SwiperSlide>
                </Swiper>
            </TabPanel>
            <TabPanel value={value} index={2} style={{ width: '1240px', margin: '0 auto' }}>
                <Swiper
                    loop={true}
                    cssMode={true}
                    navigation={true}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    pagination={true}
                    modules={[Navigation, Pagination, Autoplay]}
                    className="mySwiper"
                >
                    <SwiperSlide>
                        <Shoesbox1 data5={data5} res5={res5}/>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Shoesbox2 data6={data6} res6={res6}/>
                    </SwiperSlide>
                </Swiper>
            </TabPanel>
            <TabPanel value={value} index={3} style={{ width: '1240px', margin: '0 auto' }}>
                <Swiper
                    loop={true}
                    cssMode={true}
                    navigation={true}
                    autoplay={{
                        delay: 2500,
                        disableOnInteraction: false,
                    }}
                    pagination={true}
                    modules={[Navigation, Pagination, Autoplay]}
                    className="mySwiper"
                >
                    <SwiperSlide>
                        <Golfbox1 data7={data7} res7={res7}/>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Golfbox2 data8={data8} res8={res8}/>
                    </SwiperSlide>
                </Swiper>
            </TabPanel>
        </Box>
    );
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}


function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`
    };
}

function Womenbox1(props) {
    return (
        <>
            {
                props.data1.map((a, i) => {
                    return (
                        <div className="box_wrap">
                            <Link to={`/detail/${props.res1[i]}`}>
                                <img src={a.imgurl} />
                                <div className="box_wrap_txtbox">
                                    <p>{a.brand}</p>
                                    <p>{a.title}</p>
                                    <span>{a.persent}</span><span>{a.price}</span><span>{a.saleprice}</span>
                                </div>
                            </Link>
                        </div>
                    )
                })
            }
        </>
    )
}

function Womenbox2(props) {
    return (
        <>
            {
                props.data2.map((a, i) => {
                    return (
                        <div className="box_wrap">
                            <Link to={`/detail/${props.res2[i]}`}>
                            <img src={a.imgurl} />
                            <div className="box_wrap_txtbox">
                                <p>{a.brand}</p>
                                <p>{a.title}</p>
                                <span>{a.persent}</span><span>{a.price}</span><span>{a.saleprice}</span>
                            </div>
                            </Link>
                        </div>
                    )
                })
            }
        </>
    )

}

function Menbox1(props) {
    return (
        <>
            {
                props.data3.map((a, i) => {
                    return (
                        <div className="box_wrap">
                            <Link to={`/detail/${props.res3[i]}`}>
                            <img src={a.imgurl} />
                            <div className="box_wrap_txtbox">
                                <p>{a.brand}</p>
                                <p>{a.title}</p>
                                <span>{a.persent}</span><span>{a.price}</span><span>{a.saleprice}</span>
                            </div>
                            </Link>
                        </div>
                    )
                })
            }
        </>
    )
}

function Menbox2(props) {
    return (
        <>
            {
                props.data4.map((a, i) => {
                    return (
                        <div className="box_wrap">
                            <Link to={`/detail/${props.res4[i]}`}>
                            <img src={a.imgurl} />
                            <div className="box_wrap_txtbox">
                                <p>{a.brand}</p>
                                <p>{a.title}</p>
                                <span>{a.persent}</span><span>{a.price}</span><span>{a.saleprice}</span>
                            </div>
                            </Link>
                        </div>
                    )
                })
            }
        </>
    )

}

function Shoesbox1(props) {
    return (
        <>
            {
                props.data5.map((a, i) => {
                    return (
                        <div className="box_wrap">
                            <Link to={`/detail/${props.res5[i]}`}>
                            <img src={a.imgurl} />
                            <div className="box_wrap_txtbox">
                                <p>{a.brand}</p>
                                <p>{a.title}</p>
                                <span>{a.persent}</span><span>{a.price}</span><span>{a.saleprice}</span>
                            </div>
                            </Link>
                        </div>
                    )
                })
            }
        </>
    )
}

function Shoesbox2(props) {
    return (
        <>
            {
                props.data6.map((a, i) => {
                    return (
                        <div className="box_wrap">
                            <Link to={`/detail/${props.res6[i]}`}>
                            <img src={a.imgurl} />
                            <div className="box_wrap_txtbox">
                                <p>{a.brand}</p>
                                <p>{a.title}</p>
                                <span>{a.persent}</span><span>{a.price}</span><span>{a.saleprice}</span>
                            </div>
                            </Link>
                        </div>
                    )
                })
            }
        </>
    )

}


function Golfbox1(props) {
    return (
        <>
            {
                props.data7.map((a, i) => {
                    return (
                        <div className="box_wrap">
                            <Link to={`/detail/${props.res7[i]}`}>
                            <img src={a.imgurl} />
                            <div className="box_wrap_txtbox">
                                <p>{a.brand}</p>
                                <p>{a.title}</p>
                                <span>{a.persent}</span><span>{a.price}</span><span>{a.saleprice}</span>
                            </div>
                            </Link>
                        </div>
                    )
                })
            }
        </>
    )
}

function Golfbox2(props) {
    return (
        <>
            {
                props.data8.map((a, i) => {
                    return (
                        <div className="box_wrap">
                            <Link to={`/detail/${props.res8[i]}`}>
                            <img src={a.imgurl} />
                            <div className="box_wrap_txtbox">
                                <p>{a.brand}</p>
                                <p>{a.title}</p>
                                <span>{a.persent}</span><span>{a.price}</span><span>{a.saleprice}</span>
                            </div>
                            </Link>
                        </div>
                    )
                })
            }
        </>
    )

}

export default NewArrival;